/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import * as React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { Title } from "react-admin";

const NotFound = () => (
  <Card>
    <Title title="Not Found" />
    <CardContent>
      <h1 className="text-center">404: Page not found</h1>
    </CardContent>
  </Card>
);

export default NotFound;
